import { render, staticRenderFns } from "./ListDataSaleMetrics.vue?vue&type=template&id=5d100809"
import script from "./ListDataSaleMetrics.vue?vue&type=script&lang=js"
export * from "./ListDataSaleMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports